var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "bg-white", attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-user" }
          }),
          _vm._v(" " + _vm._s(_vm.$t(_vm.page_title)) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-xs" }, [
        _vm.register_others.help_header_slug
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-alert",
                  {
                    attrs: {
                      color: "primary",
                      icon: "fal fa-exclamation-triangle"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t(_vm.register_others.help_header_slug)) +
                        "\n\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("personal_data")))
          ])
        ]),
        _vm.register_fields.name
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("name") +
                      " " +
                      (_vm.register_fields.name_mandatory ? "*" : ""),
                    error: _vm.$v.full_name.$error
                  },
                  on: { input: _vm.$v.full_name.$touch },
                  model: {
                    value: _vm.full_name,
                    callback: function($$v) {
                      _vm.full_name = $$v
                    },
                    expression: "full_name"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.email_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  { attrs: { error: _vm.email_error } },
                  [
                    _vm.email_error
                      ? _c(
                          "span",
                          {
                            attrs: { slot: "error-label" },
                            slot: "error-label"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("email_already_in_use_click")) +
                                "\n\t\t\t\t\t"
                            ),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "recover-password",
                                    params: {
                                      email: _vm.email ? _vm.email : "",
                                      document: ""
                                    }
                                  }
                                }
                              },
                              [_c("strong", [_vm._v(_vm._s(_vm.$t("here")))])]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("to_recover_your_password")) +
                                "\n\t\t\t\t"
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("q-input", {
                      attrs: {
                        type: "email",
                        "float-label":
                          _vm.$t("email") +
                          " " +
                          (_vm.register_fields.email_fields_mandatory
                            ? "*"
                            : ""),
                        error: _vm.$v.email.$error,
                        disable: _vm.disable_email
                      },
                      on: {
                        input: _vm.$v.email.$touch,
                        blur: function($event) {
                          return _vm.emailUnique()
                        }
                      },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.email_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  attrs: {
                    type: "email",
                    "float-label":
                      _vm.$t("email_confirm") +
                      " " +
                      (_vm.register_fields.email_fields_mandatory ? "*" : ""),
                    error: _vm.$v.email_confirm.$error,
                    disable: _vm.disable_email
                  },
                  on: { input: _vm.$v.email_confirm.$touch },
                  model: {
                    value: _vm.email_confirm,
                    callback: function($$v) {
                      _vm.email_confirm = $$v
                    },
                    expression: "email_confirm"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.document
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  { attrs: { error: _vm.document_error } },
                  [
                    _vm.document_error
                      ? _c(
                          "span",
                          {
                            attrs: { slot: "error-label" },
                            slot: "error-label"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("document_already_in_use_click")
                                ) +
                                "\n\t\t\t\t\t"
                            ),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "recover-password",
                                    params: {
                                      email: "",
                                      document: _vm.document ? _vm.document : ""
                                    }
                                  }
                                }
                              },
                              [_c("strong", [_vm._v(_vm._s(_vm.$t("here")))])]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("to_recover_your_password")) +
                                "\n\t\t\t\t"
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("q-input", {
                      attrs: {
                        "float-label":
                          (_vm.clientName === "academiacoral" ||
                          _vm.clientName === "siemens"
                            ? _vm.$t("document_cpf")
                            : _vm.$t("document")) +
                          " " +
                          (_vm.register_fields.document_mandatory ? "*" : ""),
                        error: _vm.$v.document.$error
                      },
                      on: {
                        input: _vm.$v.document.$touch,
                        blur: function($event) {
                          return _vm.documentUnique()
                        }
                      },
                      model: {
                        value: _vm.document,
                        callback: function($$v) {
                          _vm.document = $$v
                        },
                        expression: "document"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.register && !_vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.register_error,
                      "error-label": _vm.register_error
                        ? _vm.$t("register_not_unique")
                        : ""
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label":
                          _vm.$t("register") +
                          " " +
                          (_vm.register_fields.register_mandatory ? "*" : ""),
                        error: _vm.$v.register.$error
                      },
                      on: {
                        input: _vm.$v.register.$touch,
                        blur: function($event) {
                          return _vm.registerUnique()
                        }
                      },
                      model: {
                        value: _vm.register,
                        callback: function($$v) {
                          _vm.register = $$v
                        },
                        expression: "register"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.register_2 && _vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.register_2_error,
                      "error-label": _vm.register_2_error
                        ? _vm.$t("gmin_number_not_unique")
                        : ""
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label":
                          _vm.$t("gmin_number") +
                          " " +
                          (_vm.register_fields.register_2_mandatory ? "*" : ""),
                        error: _vm.$v.register_2.$error
                      },
                      on: {
                        input: _vm.$v.register_2.$touch,
                        blur: function($event) {
                          return _vm.register2Unique()
                        }
                      },
                      model: {
                        value: _vm.register_2,
                        callback: function($$v) {
                          _vm.register_2 = $$v
                        },
                        expression: "register_2"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.birthday
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-datetime", {
                  attrs: {
                    type: "date",
                    "float-label":
                      _vm.$t("birthday") +
                      " " +
                      (_vm.register_fields.birthday_mandatory ? "*" : ""),
                    format: "DD/MM"
                  },
                  model: {
                    value: _vm.birthday,
                    callback: function($$v) {
                      _vm.birthday = $$v
                    },
                    expression: "birthday"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.gender
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  attrs: {
                    options: _vm.genders,
                    "float-label":
                      _vm.$t("gender") +
                      " " +
                      (_vm.register_fields.gender_mandatory ? "*" : ""),
                    clearable: ""
                  },
                  model: {
                    value: _vm.gender,
                    callback: function($$v) {
                      _vm.gender = $$v
                    },
                    expression: "gender"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row gutter-xs q-mt-sm" }, [
        _vm.register_fields.is_handicapped
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  attrs: {
                    options: [
                      { value: true, label: _vm.$t("yes") },
                      { value: false, label: _vm.$t("no") }
                    ],
                    "float-label":
                      _vm.$t("is_handicapped") +
                      " " +
                      (_vm.register_fields.is_handicapped_mandatory ? "*" : "")
                  },
                  model: {
                    value: _vm.is_handicapped,
                    callback: function($$v) {
                      _vm.is_handicapped = $$v
                    },
                    expression: "is_handicapped"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.handicap_description
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("handicap_description") +
                      " " +
                      (_vm.register_fields.handicap_description_mandatory
                        ? "*"
                        : ""),
                    error: _vm.$v.handicap_description.$error,
                    disable: !_vm.is_handicapped
                  },
                  on: { input: _vm.$v.handicap_description.$touch },
                  model: {
                    value: _vm.handicap_description,
                    callback: function($$v) {
                      _vm.handicap_description = $$v
                    },
                    expression: "handicap_description"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row gutter-xs" }, [
        _vm.showPhones
          ? _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
              _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("phone_number")))
              ])
            ])
          : _vm._e(),
        _vm.register_fields.mobile_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("mobile") +
                      " " +
                      (_vm.register_fields.mobile_phone_fields_mandatory
                        ? "*"
                        : ""),
                    error: _vm.$v.phone_mobile.phone.$error
                  },
                  on: { input: _vm.$v.phone_mobile.phone.$touch },
                  model: {
                    value: _vm.phone_mobile.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_mobile, "phone", $$v)
                    },
                    expression: "phone_mobile.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.whatsapp_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("whatsapp") +
                      " " +
                      (_vm.register_fields.whatsapp_phone_fields_mandatory
                        ? "*"
                        : ""),
                    error: _vm.$v.phone_whatsapp.phone.$error
                  },
                  on: { input: _vm.$v.phone_whatsapp.phone.$touch },
                  model: {
                    value: _vm.phone_whatsapp.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_whatsapp, "phone", $$v)
                    },
                    expression: "phone_whatsapp.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.commercial_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("commercial") +
                      " " +
                      (_vm.register_fields.commercial_phone_fields_mandatory
                        ? "*"
                        : ""),
                    error: _vm.$v.phone_commercial.phone.$error
                  },
                  on: { input: _vm.$v.phone_commercial.phone.$touch },
                  model: {
                    value: _vm.phone_commercial.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_commercial, "phone", $$v)
                    },
                    expression: "phone_commercial.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.residential_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("residential") +
                      " " +
                      (_vm.register_fields.residential_phone_fields_mandatory
                        ? "*"
                        : ""),
                    error: _vm.$v.phone_residential.phone.$error
                  },
                  on: { input: _vm.$v.phone_residential.phone.$touch },
                  model: {
                    value: _vm.phone_residential.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_residential, "phone", $$v)
                    },
                    expression: "phone_residential.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
              _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("address")))
              ])
            ])
          : _vm._e(),
        _vm.keyGooogleMaps
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.show_maps_alert,
                      "error-label": _vm.$t(
                        "not_found_check_that_the_search_is_spelled_correctly_Try_adding_a_city_state_or_zip_code"
                      )
                    }
                  },
                  [
                    _c(
                      "q-input",
                      {
                        attrs: {
                          "float-label": _vm.$t("address"),
                          autocomplete: "new-password",
                          error: _vm.$v.address.$error,
                          placeholder: _vm.$t(
                            "search_by_name_and_street_number"
                          )
                        },
                        on: { input: _vm.$v.address.$touch },
                        model: {
                          value: _vm.address,
                          callback: function($$v) {
                            _vm.address = $$v
                          },
                          expression: "address"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { "min-characters": 3, separator: "" },
                          on: {
                            search: _vm.getAddressGoogleMaps,
                            selected: _vm.selectedAddressGoogleMaps
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
              _vm.register_fields.address_fields
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            "float-label":
                              _vm.$t("address") +
                              " " +
                              (_vm.register_fields.address_fields_mandatory
                                ? "*"
                                : ""),
                            autocomplete: "new-password",
                            error: _vm.$v.address.$error
                          },
                          on: { input: _vm.$v.address.$touch },
                          model: {
                            value: _vm.address,
                            callback: function($$v) {
                              _vm.address = $$v
                            },
                            expression: "address"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: { "min-characters": 3, separator: "" },
                            on: {
                              search: _vm.getAddress,
                              selected: _vm.selectedAddress
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  ref: "number",
                  attrs: { "float-label": _vm.$t("number") },
                  model: {
                    value: _vm.number,
                    callback: function($$v) {
                      _vm.number = $$v
                    },
                    expression: "number"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: { "float-label": _vm.$t("complement") },
                  model: {
                    value: _vm.complement,
                    callback: function($$v) {
                      _vm.complement = $$v
                    },
                    expression: "complement"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("neighborhood") +
                      " " +
                      (_vm.register_fields.address_fields_mandatory ? "*" : "")
                  },
                  model: {
                    value: _vm.neighborhood,
                    callback: function($$v) {
                      _vm.neighborhood = $$v
                    },
                    expression: "neighborhood"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("postal_code") +
                      " " +
                      (_vm.register_fields.address_fields_mandatory ? "*" : "")
                  },
                  model: {
                    value: _vm.postal_code,
                    callback: function($$v) {
                      _vm.postal_code = $$v
                    },
                    expression: "postal_code"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("city") +
                      " " +
                      (_vm.register_fields.address_fields_mandatory ? "*" : ""),
                    error: _vm.$v.city.$error
                  },
                  on: { input: _vm.$v.city.$touch },
                  model: {
                    value: _vm.city,
                    callback: function($$v) {
                      _vm.city = $$v
                    },
                    expression: "city"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.$t("state") +
                      " " +
                      (_vm.register_fields.address_fields_mandatory ? "*" : ""),
                    error: _vm.$v.state.$error
                  },
                  on: { input: _vm.$v.state.$touch },
                  model: {
                    value: _vm.state,
                    callback: function($$v) {
                      _vm.state = $$v
                    },
                    expression: "state"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.clientName !== "contiacademy" && _vm.clientName !== "universidadeasus"
        ? _c("div", { staticClass: "row gutter-xs" }, [
            _vm.register_fields.store
              ? _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
                  _c("span", { staticClass: "q-headline text-weight-light" }, [
                    _vm._v(_vm._s(_vm.$t("company")))
                  ])
                ])
              : _vm._e(),
            _vm.showCountries
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.countries,
                        "float-label":
                          _vm.$t("country") +
                          " " +
                          (_vm.register_fields.store_mandatory ? "*" : ""),
                        error: _vm.$v.country.$error
                      },
                      on: {
                        input: function($event) {
                          return _vm.loadStores()
                        }
                      },
                      model: {
                        value: _vm.country,
                        callback: function($$v) {
                          _vm.country = $$v
                        },
                        expression: "country"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.register_fields.store && !_vm.register_others.store_as_list
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-input",
                      {
                        attrs: {
                          "float-label":
                            _vm.$t("company") +
                            " " +
                            (_vm.register_fields.store_mandatory ? "*" : ""),
                          error: _vm.$v.store_code.$error,
                          disable: !_vm.country
                        },
                        on: { input: _vm.$v.store_code.$touch },
                        model: {
                          value: _vm.store_code,
                          callback: function($$v) {
                            _vm.store_code = $$v
                          },
                          expression: "store_code"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { "min-characters": 3 },
                          on: {
                            search: _vm.searchStore,
                            selected: _vm.selectedStore
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.register_fields.store && _vm.register_others.store_as_list
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.stores,
                        "float-label":
                          _vm.$t("company") +
                          " " +
                          (_vm.register_fields.store_mandatory ? "*" : ""),
                        error: _vm.$v.store_code.$error,
                        disable: !_vm.country,
                        filter: ""
                      },
                      on: { input: _vm.selectStoreList },
                      model: {
                        value: _vm.store_code,
                        callback: function($$v) {
                          _vm.store_code = $$v
                        },
                        expression: "store_code"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.show_other_company
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("others"),
                        error: _vm.$v.other_company.$error
                      },
                      on: { input: _vm.$v.other_company.$touch },
                      model: {
                        value: _vm.other_company,
                        callback: function($$v) {
                          _vm.other_company = $$v
                        },
                        expression: "other_company"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._l(_vm.selected_store.clients, function(client, index) {
        return _vm.register_fields.store_profile &&
          !_vm.show_other_company &&
          _vm.clientName !== "contiacademy" &&
          _vm.clientName !== "universidadeasus"
          ? _c("div", { staticClass: "row gutter-xs" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.getProfileOptionsClient(client),
                      "float-label":
                        _vm.$t("select_profile") + " - " + client.name,
                      error: client.has_error
                    },
                    on: {
                      input: function($event) {
                        client.has_error = false
                      }
                    },
                    model: {
                      value: client.profile,
                      callback: function($$v) {
                        _vm.$set(client, "profile", $$v)
                      },
                      expression: "client.profile"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      }),
      _vm.register_fields.store_profile &&
      _vm.show_other_company &&
      _vm.clientName !== "contiacademy" &&
      _vm.clientName !== "universidadeasus"
        ? _c("div", { staticClass: "row gutter-xs" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: _vm.getProfileOptions(_vm.profiles),
                    "float-label": _vm.$t("profile"),
                    error: _vm.$v.profile.$error
                  },
                  on: { input: _vm.$v.profile.$touch },
                  model: {
                    value: _vm.profile,
                    callback: function($$v) {
                      _vm.profile = $$v
                    },
                    expression: "profile"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.register_fields.store_profile &&
      !_vm.show_other_company &&
      _vm.clientName === "siemens"
        ? _c("div", { staticClass: "row gutter-xs" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: _vm.getProfileOptions(_vm.profiles),
                    "float-label": _vm.$t("profile"),
                    error: _vm.$v.profile.$error
                  },
                  on: { input: _vm.$v.profile.$touch },
                  model: {
                    value: _vm.profile,
                    callback: function($$v) {
                      _vm.profile = $$v
                    },
                    expression: "profile"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.register_fields.store_profile &&
      !_vm.show_other_company &&
      _vm.clientName === "academiacoral"
        ? _c("div", { staticClass: "row gutter-xs" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: _vm.getProfileOptionsCoral(_vm.profiles),
                    "float-label": _vm.$t("profile"),
                    error: _vm.$v.profile.$error
                  },
                  on: { input: _vm.$v.profile.$touch },
                  model: {
                    value: _vm.profile,
                    callback: function($$v) {
                      _vm.profile = $$v
                    },
                    expression: "profile"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.clientName === "contiacademy"
        ? _c("div", { staticClass: "row gutter-xs" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
              _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("company")))
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: _vm.countries,
                    "float-label":
                      _vm.$t("country") +
                      " " +
                      (_vm.register_fields.store_mandatory ? "*" : ""),
                    error: _vm.$v.country.$error
                  },
                  model: {
                    value: _vm.country,
                    callback: function($$v) {
                      _vm.country = $$v
                    },
                    expression: "country"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: [
                      { value: true, label: _vm.$t("yes") },
                      { value: false, label: _vm.$t("no") }
                    ],
                    "float-label": _vm.$t("are_you_a_continental_partner"),
                    disable: !_vm.country
                  },
                  on: { input: _vm.changeContiacademyPartner },
                  model: {
                    value: _vm.contiacademy_partner,
                    callback: function($$v) {
                      _vm.contiacademy_partner = $$v
                    },
                    expression: "contiacademy_partner"
                  }
                })
              ],
              1
            ),
            _vm.contiacademy_partner
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          error: _vm.sap_code_error,
                          "error-label": _vm.contiacademy_custom_store_error_label
                            ? _vm.$t("wait_load_and_select_store_code")
                            : _vm.$t("sap_code_error")
                        }
                      },
                      [
                        _c(
                          "q-input",
                          {
                            attrs: {
                              "float-label": _vm.$t("sap_code") + " *",
                              error:
                                _vm.$v.store_code.$error ||
                                _vm.selected_store.length > 0,
                              disable: !_vm.country
                            },
                            on: { input: _vm.$v.store_code.$touch },
                            model: {
                              value: _vm.store_code,
                              callback: function($$v) {
                                _vm.store_code = $$v
                              },
                              expression: "store_code"
                            }
                          },
                          [
                            _c("q-autocomplete", {
                              attrs: { "min-characters": 3 },
                              on: {
                                search: _vm.searchStoreConti,
                                selected: _vm.selectedStore
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.contiacademy_partner
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  _vm._l(_vm.selected_store.clients, function(client, index) {
                    return _c("div", { staticClass: "row gutter-xs" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: index === 0,
                              expression: "index === 0"
                            }
                          ],
                          staticClass: "col-xs-12 col-sm-12"
                        },
                        [
                          _c("q-select", {
                            attrs: {
                              options: client.profiles,
                              "float-label": "" + _vm.$t("select_profile"),
                              error: client.has_error
                            },
                            on: { input: _vm.changeProfilesContiacademy },
                            model: {
                              value: client.profile,
                              callback: function($$v) {
                                _vm.$set(client, "profile", $$v)
                              },
                              expression: "client.profile"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.clientName == "universidadeasus"
        ? _c("div", { staticClass: "row gutter-xs" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
              _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("company")))
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: [
                      { value: true, label: _vm.$t("yes") },
                      { value: false, label: _vm.$t("no") }
                    ],
                    "float-label": _vm.$t("you_are_a_retailer") + " *",
                    error: _vm.$v.asus_partner.$error,
                    disable: !_vm.country
                  },
                  on: { input: _vm.changeAsusPartner },
                  model: {
                    value: _vm.asus_partner,
                    callback: function($$v) {
                      _vm.asus_partner = $$v
                    },
                    expression: "asus_partner"
                  }
                })
              ],
              1
            ),
            _vm.asus_partner
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.stores,
                        "float-label":
                          _vm.$t("company") +
                          " " +
                          (_vm.register_fields.store_mandatory ? "*" : ""),
                        error: _vm.$v.store_code.$error,
                        disable: !_vm.country,
                        filter: ""
                      },
                      on: { input: _vm.changeAsusProfile },
                      model: {
                        value: _vm.store_code,
                        callback: function($$v) {
                          _vm.store_code = $$v
                        },
                        expression: "store_code"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.asus_partner === false
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  _vm._l(_vm.selected_store.clients, function(client, index) {
                    return _vm.register_fields.store_profile &&
                      !_vm.show_other_company
                      ? _c("div", { staticClass: "row gutter-xs" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-12" },
                            [
                              _c("q-select", {
                                attrs: {
                                  options: client.profiles,
                                  "float-label":
                                    _vm.$t("select_profile") +
                                    " - " +
                                    client.name,
                                  error: client.has_error
                                },
                                on: {
                                  input: function($event) {
                                    client.has_error = false
                                  }
                                },
                                model: {
                                  value: client.profile,
                                  callback: function($$v) {
                                    _vm.$set(client, "profile", $$v)
                                  },
                                  expression: "client.profile"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.register_others.use_accept_terms
        ? _c("div", { staticClass: "row gutter-xs justify-end q-mt-lg" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3 text-right" },
              [
                _c("q-checkbox", {
                  class: _vm.$v.accept_terms_and_conditions.$error
                    ? "text-negative"
                    : "",
                  attrs: { label: _vm.$t("accept_terms_and_conditions") },
                  on: {
                    input: function($event) {
                      return _vm.showTerms()
                    }
                  },
                  model: {
                    value: _vm.accept_terms_and_conditions,
                    callback: function($$v) {
                      _vm.accept_terms_and_conditions = $$v
                    },
                    expression: "accept_terms_and_conditions"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "login" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.closeUserPreCreated()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("ok") },
                    on: {
                      click: function($event) {
                        return _vm.closeUserPreCreated()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.user_pre_created,
            callback: function($$v) {
              _vm.user_pre_created = $$v
            },
            expression: "user_pre_created"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("user_registered")))
          ]),
          _c("span", { attrs: { slot: "body" }, slot: "body" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t(
                    "your_account_has_been_created_and_is_awaiting_for_aproval_you_will_receive_an_email"
                  )
                ) +
                "\n\t\t"
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.closeUserCreated()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("ok") },
                    on: {
                      click: function($event) {
                        return _vm.closeUserCreated()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.user_created,
            callback: function($$v) {
              _vm.user_created = $$v
            },
            expression: "user_created"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("user_registered")))
          ]),
          _c("span", { attrs: { slot: "body" }, slot: "body" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t(
                    "your_account_has_been_created_verify_your_email_for_instructions"
                  )
                ) +
                "\n\t\t"
            )
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            hide: function($event) {
              _vm.show_terms = false
            }
          },
          model: {
            value: _vm.show_terms,
            callback: function($$v) {
              _vm.show_terms = $$v
            },
            expression: "show_terms"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_terms = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("terms_and_conditions")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row text-weight-regular q-pt-md" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.getTerm) } })
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-sm" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "negative",
                            label: _vm.$t("reject_terms"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rejectTerms()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "positive",
                            label: _vm.$t("accept_terms"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.acceptTerms()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: {
                      color: "positive",
                      icon: "fal fa-sign-in",
                      label: _vm.$t("access_platform")
                    },
                    on: { click: _vm.academiaCoralAutoLogin }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_academiacoral_welcome,
            callback: function($$v) {
              _vm.show_academiacoral_welcome = $$v
            },
            expression: "show_academiacoral_welcome"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("user_registered_success")))
          ]),
          _c("div", { attrs: { slot: "message" }, slot: "message" }, [
            _c("p", { attrs: { slot: "message" }, slot: "message" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("academiacoral_registered_success")) +
                  "\n\t\t\t"
              )
            ]),
            _c("p", { attrs: { slot: "message" }, slot: "message" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("use_document_and_default_password_to_login")) +
                  "\n\t\t\t"
              )
            ]),
            _c("p", { attrs: { slot: "message" }, slot: "message" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("password")) + ": "),
              _c("strong", [_vm._v(_vm._s(_vm.academiacoral_default_password))])
            ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }